import React from "react";
import { FaCheck } from "react-icons/fa";
import { CgAdd } from "react-icons/cg";

const ImageGridArea = ({
  slots = [],
  stagedDeletes = new Set(),
  toggleStage = () => { },
  onAddMore = () => { },
}) => {
  const images = slots.filter(Boolean);

  return (
    <div className="flex-1 overflow-y-auto w-full max-w-[360px] md:max-w-[700px] mx-auto overflow-x-hidden min-h-0">
      <h2 className="text-center font-instrument font-semibold text-[16px] mb-[13px] text-[#7876A1]">
        Select your images.
      </h2>
      <div className="w-full flex justify-center">
        <div className="grid grid-cols-3 md:grid-cols-5 gap-[8px] justify-items-center">

          {/* IMAGES */}
          {images.map((item, idx) => {
            const isStaged = stagedDeletes.has(item.id);

            return (
              <div
                key={item.id || idx}
                role="button"
                tabIndex={0}
                onClick={() => toggleStage(item.id)}
                className={`
                  relative
                  w-[80px] h-[80px]                             /* <375px */
                  [@media(min-width:375px)]:w-[100px]           /* 375px+ */
                  [@media(min-width:375px)]:h-[100px]           /* 375px+ */
                  [@media(min-width:390px)]:w-[103px]          /* 390px+ */
                  [@media(min-width:390px)]:h-[103px]          /* 390px+ */
                  md:w-[120px] md:h-[120px]                     /* md+ */
                  ${isStaged ? "opacity-40" : ""}
                `}
              >
                <img
                  src={item.preview}
                  alt="selected"
                  className="w-full h-full object-cover border-2 border-[var(--primary)]"
                />

                {!isStaged && (
                  <div className="absolute top-1 right-1 bg-white border-2 border-[var(--primary)] w-5 h-5 flex items-center justify-center">
                    <FaCheck className="text-[10px] text-[var(--primary)]" />
                  </div>
                )}
              </div>
            );
          })}

          {/* ADD MORE */}
          <div
            role="button"
            tabIndex={0}
            onClick={() => onAddMore(images.length)}
            className={`
              relative cursor-pointer font-instrument
              w-[80px] h-[80px]                             /* <375px */
              [@media(min-width:375px)]:w-[100px]           /* 375px+ */
              [@media(min-width:375px)]:h-[100px]           /* 375px+ */
              [@media(min-width:390px)]:w-[103px]          /* 390px+ */
              [@media(min-width:390px)]:h-[103px]          /* 390px+ */
              md:w-[120px] md:h-[120px]                     /* md+ */
            `}
          >
            <div className="w-full h-full flex flex-col items-center justify-center bg-[#F6F6FD] border-2 border-[#34318C] gap-y-1 hover:bg-[#E0E0F0] transition">
              <span className="text-[12px] md:text-[16px] text-[#34318C] font-semibold text-center">
                Add <span className="block md:inline">More</span>
              </span>
              <CgAdd size={20} color="#34318C" />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ImageGridArea;
